import { OverViewWrapper } from './styled'
import React, { Suspense } from 'react'
import { ScopeProviderWithInitializer } from 'components/scope-provider'
import { OverviewLoading } from './loading'
import { createOverviewStorage } from './storage'
import { OverviewPageWrapper } from './overview-wrapper'

export const OverviewPage: React.FC = () => {
  const createdStorage = createOverviewStorage()
  return (
    <OverViewWrapper>
      <ScopeProviderWithInitializer atomValues={createdStorage}>
        <Suspense fallback={<OverviewLoading />}>
          <OverviewPageWrapper />
        </Suspense>
      </ScopeProviderWithInitializer>
    </OverViewWrapper>
  )
}
